<div class="modal-header">
	<h4 class="modal-title">{{'labels.add-building' | translate}}</h4>
	<button
		type="button"
		class="close"
		aria-label="Close"
		(click)="dismiss()">
		<span aria-hidden="true">×</span>
	</button>
</div>

<div
	class="modal-body"
	ngbAutofocus>
	<div
		class="row"
		*ngIf="associableloading">
		<div class="col text-center">
			<app-loader [material]="false"></app-loader>
		</div>
	</div>

	<div class="row">
		<div
			class="col-md-3"
			*ngIf="!singlecompany">

			<label>
				{{'labels.choose-company' | translate }}
			</label>
		</div>
		<div
			*ngIf="!singlecompany"
			class="col-md-3 form-group">
			<select
				class="form-control custom-select"
				[(ngModel)]="companyid"
				(change)="reloadbuildings()">
				<option [value]="0">{{'labels.all-company' | translate}}</option>
				<option
					*ngFor="let p of partecipants"
					[value]="p.entityobj.id">
					{{p.entityobj.name}}
				</option>
			</select>

		</div>
		<div class="col-md-3">
			<label>
				{{'labels.filter-building' | translate }}
			</label>

		</div>
		<div class="col-md-3 form-group">

			<input
				type="text"
				class="form-control"
				placeholder="{{'labels.building' | translate}}"
				(keyup)="updateFilter($event)">
		</div>
	</div>

	<div
		class="company-filter"
		*ngIf="!associableloading">

	</div>

	<div
		class="table-responsive"
		*ngIf="!associableloading">

		<div class="row">
			<div
				class="col-md-6"
				*ngIf="!associableloading">

				<h4>
					{{'labels.associable-building' | translate}}
				</h4>

				<ngx-datatable
					[tablefix]="datatable"
					#datatable
					class="bootstrap"
					[rows]="associablerows"
					[columnMode]="'flex'"
					[rowHeight]="'auto'"
					[headerHeight]="50"
					[footerHeight]="30"
					[externalPaging]="false"
					[externalSorting]="false"
					[loadingIndicator]="associableloading"
					[messages]="{
          emptyMessage: 'labels.empty-buildings' | translate,
          totalMessage: 'labels.total' | translate
		}">

					<ngx-datatable-column
						prop="name"
						[flexGrow]="1"
						[name]="'labels.name' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						[flexGrow]="1"
						[sortable]="false"
						[resizeable]="false"
						[cellClass]="'text-center'">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="icon-buttons">
								<a
									(click)="add(row)"
									class="link">
									<i
										container="body"
										ngbTooltip="{{'labels.add' | translate}}"
										class="feather icon-plus"></i>
								</a>
							</div>
						</ng-template>
					</ngx-datatable-column>
				</ngx-datatable>
			</div>
			<div
				class="col-md-6"
				*ngIf="!associateloading">
				<h4>
					{{'labels.associate-building' | translate}}
				</h4>

				<ngx-datatable
					[tablefix]="datatable"
					#datatable
					class="bootstrap"
					[rows]="associaterows"
					[columnMode]="'flex'"
					[rowHeight]="'auto'"
					[headerHeight]="50"
					[footerHeight]="30"
					[externalPaging]="false"
					[externalSorting]="false"
					[loadingIndicator]="associateloading"
					[messages]="{
          emptyMessage: 'labels.empty-buildings' | translate,
          totalMessage: 'labels.total' | translate
		}">

					<ngx-datatable-column
						prop="name"
						[flexGrow]="1"
						[name]="'labels.name' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						[flexGrow]="1"
						[sortable]="false"
						[resizeable]="false"
						[cellClass]="'text-center'">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="icon-buttons">
								<a
									(click)="remove(row)"
									class="link">
									<i
										container="body"
										ngbTooltip="{{'labels.remove' | translate}}"
										class="feather icon-minus"></i>
								</a>
							</div>
						</ng-template>
					</ngx-datatable-column>
				</ngx-datatable>
			</div>
		</div>

	</div>
</div>
